import React from "react";
import ServicesPremium from "../sections/ServicesPremium";

const projectImages = [
  "/img/portfolio/01-large.jpg",
  "/img/portfolio/02-large.jpg",
  "/img/portfolio/03-large.jpg",
  "/img/portfolio/04-large.jpg",
  "/img/portfolio/05-large.jpg",
  "/img/portfolio/06-large.jpg",
];

const ProjectsPage = () => {
  return (
    <main>
      <ServicesPremium className="bg-slate-200" />
<section className="relative overflow-hidden py-20" >
        <div
          className="pointer-events-none absolute inset-0 opacity-25"
          aria-hidden="true"
          style={{
            backgroundImage:
              "linear-gradient(rgba(148,163,184,0.12) 1px, transparent 1px), linear-gradient(90deg, rgba(148,163,184,0.12) 1px, transparent 1px)",
            backgroundSize: "64px 64px",
          }}
        />
        <div className="pointer-events-none absolute inset-0 opacity-30" aria-hidden="true">
          <div className="absolute right-8 top-6 text-[96px] font-black leading-none text-transparent [background:linear-gradient(135deg,rgba(203,213,225,0.28),rgba(148,163,184,0.08))] bg-clip-text">
            120m
          </div>
          <div className="absolute left-8 bottom-4 text-[84px] font-black leading-none text-transparent [background:linear-gradient(135deg,rgba(226,232,240,0.25),rgba(148,163,184,0.08))] bg-clip-text">
            75m
          </div>
        </div>
        <div className="section-shell relative z-10">
          <div className="section-title">
            <p className="section-kicker">Projects</p>
            <h2 className="section-heading">Selected project visuals</h2>
          </div>
          <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {projectImages.map((src) => (
              <article
                key={src}
                className="overflow-hidden rounded-2xl border border-white/20 bg-slate-200/10 backdrop-blur-sm"
              >
                <img src={src} alt="Project visual" className="h-56 w-full object-cover" />
              </article>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

export default ProjectsPage;
